import React, {useEffect, useMemo, useState} from 'react';
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";
import {BoldCollapseText, ClickableDiv, FlexColumnSection, FlexRowSection} from "../../../styles/globalStyles";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {isRTL} from "../../../helpers/i18n";
import styled from "styled-components";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {t} from "i18next";
import {Spin} from "antd";
import {
    addFiltersToQueryParams,
    getBoxCategoriesGroupsFromCourses,
    removePropFromQueryParams
} from "../../../helpers/functions";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import CustomSelect from "../../../components/UI/CustomSelect";

const CourseGroupType = (props) => {
    const { values, setFieldValue, handleSubmit } = props;
    const globalLocation = useSelector(state => state.site.selectedLocation);
    const box = useSelector(state => state.site.box);
    const [fetching, setFetching] = useState(false);
    const [groups, setGroups] = useState(null);
    const [submit, setSubmit] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);

    const locationOptions = useMemo(() => {
        if (!box?.locations_box?.length) return [];
        return [{id: 'all', location: t('all-locations')}, ...box.locations_box];
    }, [box]);

    useEffect(() => {
        removePropFromQueryParams(navigate, 'filters');
        if (params.allLocations === 'true') {
            setSelectedLocation('all');
        } else if (params.location) {
            setSelectedLocation(Number(params.location));
        } else if (globalLocation) {
            setSelectedLocation(globalLocation.id);
        }
    }, [globalLocation]);

    useEffect(() => {
        if (!selectedLocation) return;

        fetchCourses();

        if (selectedLocation !== 'all') {
            addFiltersToQueryParams(navigate, {location: selectedLocation, allLocations: false});
        } else {
            addFiltersToQueryParams(navigate, {allLocations: true});
        }
    }, [selectedLocation]);

    useEffect(() => {
        if (submit) {
            handleSubmit();
            setSubmit(false);
        }
    }, [submit, values.category_group_id]);

    const fetchCourses = async () => {
        setFetching(true);
        setGroups(null);
        const coursesRes = await apiAction(`getHugim`, 'post', {
            location_id: selectedLocation === 'all' ? null : selectedLocation,
            user_id: null
        });
        const groupsArray = getBoxCategoriesGroupsFromCourses(coursesRes, t('no-course-group'));
        setGroups(groupsArray);
        setFetching(false);
    };

    const selectGroup = (group) => {
        setFieldValue('category_group_id', group.id);
        setSubmit(true);
    };

    return (
        <FlexColumnSection gap={'10px'} overflow={'auto'}>
            {locationOptions.length > 2 && selectedLocation && (
                <FlexRowSection flex={'none'}>
                    <CustomSelect
                        onChange={(val) => val ? setSelectedLocation(val) : null}
                        options={locationOptions}
                        defaultValue={selectedLocation}
                        valueProp={'id'}
                        labelProp={'location'}
                        style={{flex: 1, maxWidth: '250px'}}
                    />
                </FlexRowSection>
            )}
            {fetching && <FlexColumnSection justify={'center'}><Spin/></FlexColumnSection>}
            {!fetching && groups?.map(groupInfo => (
                <WhiteItem key={`group-${groupInfo.id}`} onClick={() => selectGroup(groupInfo)}>
                    <BoldCollapseText>{groupInfo.name}</BoldCollapseText>
                    <FontAwesomeIcon icon={solid('chevron-left')} color={Colors.siteBlack} size={'xs'} flip={isRTL() ? 'vertical' : 'horizontal'}/>
                </WhiteItem>
            ))}
        </FlexColumnSection>
    );
};

export default CourseGroupType;

const WhiteItem = styled(ClickableDiv)`
    display: flex;
    flex-direction: row;
    background-color: white;
    padding: 20px;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    :hover {
        box-shadow: 0px 3px 10px #21212114;
    }
`
